import { DailyMealRecord } from "../api/dailyAvailability";

export function getDailyMealStatus(record: DailyMealRecord): "OFF_SCHEDULE" | "SOLD_OUT" | "PAUSED" | "LIVE" {
  const scheduled = Boolean(record.appliedRuleId || ["MANUAL_ADDITION", "SWAP_SET"].includes(record.source) || record.isManuallyOverridden || record.isAvailable);
  if (!scheduled) return "OFF_SCHEDULE";
  if (record.stockMode === "LIMITED" && (record.remainingQuantity || 0) <= 0) return "SOLD_OUT";
  return record.isAvailable ? "LIVE" : "PAUSED";
}
